const isPluginAvailable = (pluginName: string, availablePlugins) =>
    Boolean(
        availablePlugins?.find(
            (plugin) =>
                plugin.name === pluginName ||
                isPluginAvailable(pluginName, plugin.options?.plugins),
        ),
    );

export default isPluginAvailable;
